"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobAreaFilter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const icons_1 = require("@ant-design/icons");
const elements_1 = require("@src/components/elements");
const normalize_string_1 = require("@src/helpers/normalize-string");
const Filter_1 = require("./filter/Filter");
const Filter_style_1 = require("./filter/Filter.style");
const Filters_style_1 = require("./Filters.style");
const offer_filter_context_1 = require("../../offer-filter-context");
const JobAreaFilter = ({ jobAreaFilterItems, loading }) => {
    const { jobAreaFiltersSelected, setJobAreaFiltersSelected } = (0, offer_filter_context_1.useOffersFilterContextValue)();
    const [search, setSearch] = react_1.default.useState('');
    const [isOpen, setIsOpen] = react_1.default.useState(false);
    const intl = (0, react_intl_1.useIntl)();
    const defaultJobAreaFiltersShownNum = 5;
    const areCurrentFiltersNotEmpty = Boolean(jobAreaFiltersSelected && jobAreaFiltersSelected.length !== 0);
    function isJobAreaFilterItemSelected(item) {
        return Boolean(jobAreaFiltersSelected === null || jobAreaFiltersSelected === void 0 ? void 0 : jobAreaFiltersSelected.includes(item.id));
    }
    const toggleJobArea = (toggledJobAreaId) => {
        let newSelectedJobAreaIds = [];
        if (jobAreaFiltersSelected.includes(toggledJobAreaId)) {
            newSelectedJobAreaIds = jobAreaFiltersSelected.filter(jobAreaId => jobAreaId !== toggledJobAreaId);
        }
        else {
            newSelectedJobAreaIds = [...jobAreaFiltersSelected, toggledJobAreaId];
        }
        setJobAreaFiltersSelected(newSelectedJobAreaIds);
    };
    const jobAreaFilters = jobAreaFilterItems
        .map(filter => ({
        ...filter,
        isDisabled: !isJobAreaFilterItemSelected(filter) && filter.count === 0,
    }))
        .filter(jobAreaFilterItem => (0, normalize_string_1.normalizeStr)(intl.formatMessage({ id: jobAreaFilterItem.translationKey })).indexOf((0, normalize_string_1.normalizeStr)(search)) >= 0)
        .sort((a, b) => {
        if (a.isDisabled && !b.isDisabled) {
            return 1;
        }
        if (!a.isDisabled && b.isDisabled) {
            return -1;
        }
        return 0;
    })
        .slice(0, isOpen ? jobAreaFilterItems.length : defaultJobAreaFiltersShownNum);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Filter_style_1.FilterTitle, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offers.filter.job_area" }) }), (0, jsx_runtime_1.jsx)(Filter_style_1.FilterSeparator, {}), (0, jsx_runtime_1.jsx)(elements_1.Input, { prefix: (0, jsx_runtime_1.jsx)(icons_1.SearchOutlined, {}), placeholder: intl.formatMessage({ id: 'offers.job_area_filter.search_placeholder' }), className: "m-b-l", onChange: e => {
                    const inputValue = e.target.value;
                    if (inputValue.length === 0) {
                        setIsOpen(false);
                    }
                    else if (inputValue.length >= 2) {
                        setIsOpen(true);
                    }
                    setSearch(inputValue);
                } }), (0, jsx_runtime_1.jsxs)("div", { className: "m-b-l font-size-m", children: [jobAreaFilters.map(filterItem => ((0, jsx_runtime_1.jsx)(Filter_1.Filter, { filterItem: filterItem, loading: loading, areCurrentFiltersNotEmpty: areCurrentFiltersNotEmpty, isSelected: jobAreaFiltersSelected === null || jobAreaFiltersSelected === void 0 ? void 0 : jobAreaFiltersSelected.includes(filterItem.id), isDisabled: filterItem.isDisabled, toggleFilter: toggleJobArea }, filterItem.id))), jobAreaFilterItems.length > defaultJobAreaFiltersShownNum && !search && ((0, jsx_runtime_1.jsxs)(Filters_style_1.ToggleFilterContentButton, { onClick: () => setIsOpen(!isOpen), type: "button", children: [isOpen && (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.hide_more_options" }), !isOpen && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.see_more_options" }), ` (${jobAreaFilterItems.length - defaultJobAreaFiltersShownNum})`] }))] }))] })] }));
};
exports.JobAreaFilter = JobAreaFilter;
